import { TabData } from '../../types';
import { getQueryVariable } from '../utils';

/**
 * Parses Teams tab's entityId and constructs {@link TabData} object from it.
 * It accepts delimiter ('--' or '::') separated and stringified JSON entityIds.
 *
 * @param {string} entityId Teams tab's entityId
 * @returns {TabData} Information about the tab
 */
export function parseEntityId(entityId?: string): TabData {
  if (!entityId) return {} as TabData;
  // Try parsing entityId as the new stringified JSON one.
  try {
    const entityJson = JSON.parse(entityId);
    if (typeof entityJson == 'object') {
      return entityJson as TabData;
    }
  } catch (error) {}

  // Backwards compatibility for old tabs using the '::' as a delimiter.
  // We should remove this and/or show a warning to users who are using the old format.
  const delimiter = entityId.includes('--') ? '--' : '::';
  const tokens = entityId.split(delimiter);
  return {
    projectId: tokens[0],
    serviceId: tokens[1],
    connectionId: tokens[2],
    defaultRoute: tokens[2],
    connectionName: getQueryVariable('connectionName') || tokens[3],
    iModel: {
      iModelId: tokens[2],
      namedVersionId: tokens[3],
      defaultViewId: tokens[4],
    },
  } as TabData;
}
